import React from 'react';
import { FiShield } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { getInitials } from '../utils/initials';

// Single consistent avatar used wherever a user/friend/member is shown.
// Renders up to two initials with the same border/colour treatment. Pass
// `selected` for in-list selection states and `owner` to show the shield.

const SIZES = {
  sm: { box: 'w-8 h-8 text-xs',  badge: 'w-3 h-3 -top-0.5 -right-0.5', shield: 'w-1.5 h-1.5' },
  md: { box: 'w-10 h-10 text-sm', badge: 'w-3.5 h-3.5 -top-0.5 -right-0.5', shield: 'w-2 h-2' },
  lg: { box: 'w-12 h-12 text-base', badge: 'w-4 h-4 -top-0.5 -right-0.5', shield: 'w-2.5 h-2.5' },
};

function AvatarBadge({
  name,
  size = 'md',
  selected = false,
  owner = false,
  className = '',
  title,
}) {
  const sz = SIZES[size] || SIZES.md;
  const initials = getInitials(name);
  const tone = selected || owner
    ? 'bg-accent text-white'
    : 'bg-surface text-text-secondary border border-border-subtle';

  return (
    <div
      className={`relative ${sz.box} rounded-full flex items-center justify-center font-medium flex-shrink-0 ${tone} ${className}`}
      title={title || name || undefined}
    >
      {initials}
      {owner && (
        <div className={`absolute ${sz.badge} bg-accent rounded-full flex items-center justify-center border border-card`}>
          <SafeIcon icon={FiShield} className={`${sz.shield} text-white`} />
        </div>
      )}
    </div>
  );
}

export default AvatarBadge;
